export const MLA_FILTER_PLACEHOLDERS_NO_LABEL = [
  '{formula}',
  '{side}',
  '{interval}',
  '{flow}',
  '{status}',
  '{usertriggered}',
  '{transaction_status}',
  '{date_range_start}',
  '{date_range_end}',
  '{amount}',
  '{max_amount}',
  '{count}',
  '{max_count}',
  '{slug}',
];
